/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import Gallery from "src/components/UI/Gallery";
import { useAppDispatch, useAppSelector } from "src/store";
import { getPostByHash } from "src/store/objave-store";
import DocumentImage from "../../assets/download-document.svg";
import { useNavigate } from "react-router-dom";
import { IconArrowDown } from "@tabler/icons-react"; // Import Tabler strelice
import "./InterneObjave.scss";

function InternaObjava() {
  const { id, hash } = useParams();
  const dispatch = useAppDispatch();
  const { hashPost } = useAppSelector((state) => state.post);
  const navigate = useNavigate();

  useEffect(() => {
    if (id && hash) {
      dispatch(getPostByHash({ hash, id }));
    }
  }, [id, dispatch]);

  return (
    <>
      {hashPost && id === hashPost.data.id.toString() && (
        <div className="internaObjavaContainer">
          <div className="row">
            <div className=" md:mb-5">
              <button
                onClick={() => navigate(-1)}
                className="btn rounded-lg mb-2"
                style={{
                  display: "inline-block",
                  fontSize: "1rem",
                }}
              >
                ← Nazad
              </button>
              <h1 className="category-title mb-4">{hashPost.data.title}</h1>
              {/* <div className="internaObjavaDate">{moment(hashPost.data.date_created).format("DD MMM YYYY")}.</div> */}
              <div className="flex flex-col sm:flex-row justify-between">
                <div className="col-lg-4 mb-5">
                  {hashPost.data && hashPost.data.image && hashPost.data.image.file_url && (
                    <img
                      alt="thumbnail"
                      className="thumbnail mb-4 internaObjavaThumbnail rounded-xl"
                      src={`${hashPost.data.image.file_url}`}
                      style={{
                        width: "100%",
                        height: "300px",
                        objectFit: "cover",
                        border: "1px solid #e6e7e9",
                      }}
                    />
                  )}
                  <div
                    className="internaObjavaContent"
                    dangerouslySetInnerHTML={{
                      __html: hashPost.data.content,
                    }}
                  ></div>
                </div>
                <div className="col-lg-7 mb-5">
                  <h3 className="mb-3 md:mt-0 internaObjavaSubtitles text-xl">Dokumenta</h3>
                  {hashPost.data.documents.length > 0 ? (
                    <ul className="list-group">
                      {[...hashPost.data.documents]
                        .sort((a, b) => b.order - a.order) // Obrnuto sortiranje po polju `order`
                        .map((document: any, index: number) => (
                          <li
                            key={document.id}
                            className={`flex flex-col sm:flex-row items-start sm:items-center justify-between p-3 mb-3 rounded-lg bg-white md:text-center text-start ${
                              index === 0
                                ? "bg-red-50 border-l-4 border-red-500 all-another-silver"
                                : "bg-gray-50 border-l-4 border-gray-300 border-t-[1px] border-r-[1px] border-b-[1px] border-gray-[230,231,233]"
                            }`}
                          >
                            {/* Dokument Info */}
                            <div className="flex items-center">
                              <img alt="document" className="w-8 h-10 object-contain mr-4" src={DocumentImage} />
                              <div className="dokument-solo">
                                <span
                                  className={`block text-base text-left ${
                                    index === 0 ? "font-semibold" : "font-medium text-gray-800"
                                  }`}
                                >
                                  {document.display_name}
                                </span>
                                {index === 0 && (
                                  <span className="inline-block mt-1 border text-xs !border-red-500 text-red-500 px-2 py-1 rounded-2xl font-semibold">
                                    Aktuelno
                                  </span>
                                )}
                              </div>
                            </div>

                            {/* Preuzmi Dugme */}
                            <div className="w-full text-center md:!w-[auto] mt-2">
                              <Link
                                to={document.public_url}
                                target="_blank"
                                className={`inline-flex items-center md:!mt-0 !mt-1 justify-center no-underline text-xs ${
                                  index === 0
                                    ? "bg-red-500 text-white hover:opacity-70 transition-opacity"
                                    : "btn border hover:!border-customGray rounded-lg "
                                } px-6 py-2 text-base font-medium rounded-lg pl-4`}
                              >
                                <IconArrowDown size={20} stroke={1.5} className="mr-2" /> {/* Strelica nadole */}
                                Preuzmi
                              </Link>
                            </div>
                          </li>
                        ))}
                    </ul>
                  ) : (
                    <p>Nema dostupnih dokumenata.</p>
                  )}
                </div>
              </div>
            </div>

            {/* Sekcija za galeriju - Ostaje na kraju */}
            {hashPost.data.images.length > 0 && (
              <div className="col-12 mb-5">
                <h3 className="mb-4 internaObjavaSubtitles">Fotografije</h3>
                <Gallery images={hashPost.data.images} />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default InternaObjava;
